import { memo } from 'react';

import { SettingsIcon } from '@air/design-icons';

import { MainSideNavItem } from '~/components/v2/components/workspace/main-side-nav/item/MainSideNavItem';
import { MAIN_SIDE_NAV_SMALL_ICON_SIZE } from '~/components/v2/components/workspace/main-side-nav/item/MainSideNavItemButton';
import { useMainSideNavItemSelected } from '~/components/v2/components/workspace/main-side-nav/useMainSideNavItemSelected';
import { accountSettingsRoutes, Routes, workspaceRoutes } from '~/constants/routes';
import { useCurrentWorkspacePermissionsContext } from '~/providers/CurrentWorkspacePermissionsProvider';
import { canSeeWorkspaceMembers } from '~/utils/permissions/workspacePermissions';

export type MainSideNavItemSettingsProps = {
  pathname: string;
};

export const MainSideNavItemSettings = memo(({ pathname }: MainSideNavItemSettingsProps) => {
  const { data: workspacePermissions } = useCurrentWorkspacePermissionsContext();
  const { isSelected } = useMainSideNavItemSelected({
    isRouteSelected: workspaceRoutes.includes(pathname) || accountSettingsRoutes.includes(pathname),
  });

  if (!canSeeWorkspaceMembers(workspacePermissions)) {
    return null;
  }

  return (
    <MainSideNavItem
      href={Routes.workspaceSettings.edit}
      icon={SettingsIcon}
      id="settings"
      isSelected={isSelected}
      iconSize={MAIN_SIDE_NAV_SMALL_ICON_SIZE}
      label="Settings"
      sidebarInteractionType="settings"
    />
  );
});

MainSideNavItemSettings.displayName = 'MainSideNavItemSettings';
